import { useContext } from "react";
import { SearchContext } from "../containers/contexts/search/SearchContext";

export const useMisbilledTrades = () => {
  const { misbilledRecordState, getMisbilledTrades } =
    useContext(SearchContext);
  return {
    misbilledRecordState,
    getMisbilledTrades,
  };
};
